import { IMultiLanguageAddress } from '@/models/place.model';

export enum PickupFiltersFields {
  REGION = 'region_id',
  SETTLEMENT = 'settlement_id',
  ADDRESS = 'address',
  PHONE = 'phone',
  IS_ACTIVE = 'is_active',
  IS_DEFAULT = 'is_default',
}

export enum PickingFormFields {
  REGION = 'region_id',
  SETTLEMENT = 'settlement_id',
  ADDRESS = 'address',
  WORKING_HOURS = 'schedule',
  PHONE = 'phone',
  IS_ACTIVE = 'is_active',
  IS_DEFAULT = 'is_default',
  LATITUDE = 'latitude',
  LONGITUDE = 'longitude',
  EXTERNAL_ID = 'external_id',
  LOCALE = 'locale',
  GOOGLE_STORE_CODE = 'google_store_code',
}

export type TGetPickupQuery = {
  [PickupFiltersFields.REGION]?: string;
  [PickupFiltersFields.SETTLEMENT]?: string;
  [PickupFiltersFields.ADDRESS]?: string;
  [PickupFiltersFields.PHONE]?: string;
  [PickupFiltersFields.IS_ACTIVE]?: boolean;
  [PickupFiltersFields.IS_DEFAULT]?: boolean;
};

export type TCreatePickingFormValues = {
  [PickingFormFields.REGION]: string;
  [PickingFormFields.SETTLEMENT]: string;
  [PickingFormFields.ADDRESS]: IMultiLanguageAddress;
  [PickingFormFields.PHONE]: string;
  [PickingFormFields.IS_ACTIVE]: boolean;
  [PickingFormFields.WORKING_HOURS]: Record<
    string,
    {
      [PickingFormFields.WORKING_HOURS]: string;
    }
  >;
  [PickingFormFields.IS_DEFAULT]: boolean;
  [PickingFormFields.LATITUDE]: number;
  [PickingFormFields.LONGITUDE]: number;
  [PickingFormFields.EXTERNAL_ID]: string;
  [PickingFormFields.GOOGLE_STORE_CODE]?: string | null;
};
